<template>
    <div v-if="items && items.length" class="toast-container position-fixed top-0 end-0 p-3">
        <Toast v-for="(item, index) in items" :key="index" v-bind="item"/>
    </div>
</template>

<script>
import Toast from "./Toast"

export default {
    name: "Toasts",
    components: {Toast},
    computed: {
        items() {
            return this.$store.state.toasts.items || []
        }
    }
}
</script>

<style scoped>

</style>

